import {fetch} from "../../utils/dataAccess";

export function launchOmniScan(barcode, inventoryId, context = {}) {
    return new Promise((resolve, reject) => {
        fetch(`/omni-scan`, {
            method: "POST",
            headers: new Headers({'Content-Type': 'application/json'}),
            body: JSON.stringify({
                barcode: barcode,
                inventoryId: inventoryId,
                context: context
        })
        })
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}